import React from 'react';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { WithStyles, createStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import serverAlertActions from './actions/serverAlertActions';
import { ServerAlertData } from './types/ServerAlertData';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const styles1 = (theme: Theme) => createStyles({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    maxWidth:333,
  },
});

//@ts-ignore
interface MySnackbarContent extends WithStyles<typeof styles1> {
  classes: any,
  className: string,
  message: any,
  onClose: Function,
  variant: 'success' | 'warning' | 'error' | 'info',
}


function MySnackbarContent(props: MySnackbarContent) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          //@ts-ignore
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={() => { onClose() }}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>,
      ]}
      {...other}
    />
  );
}

//@ts-ignore
const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);






const styles2 = (theme: Theme) => createStyles({
  margin: {
    margin: theme.spacing.unit,
  },
});

//@ts-ignore
interface MyPATSnackbarProps extends WithStyles<typeof styles2> {
  classes: any,
  dispatch: any,
  message: any,
  variant: 'success' | 'warning' | 'error' | 'info',
  open: boolean,
  hideAlert: (id: string) => void;
  serverAlert: ServerAlertData[]
}

interface MyPATSnackbarState {
  open: boolean
}

class MyPATSnackbar extends React.Component<MyPATSnackbarProps, MyPATSnackbarState> {

  constructor(props: MyPATSnackbarProps, state: MyPATSnackbarState) {
    super(props)

  }


  handleClick = () => {
  };

  render() {
    const { classes, serverAlert } = this.props;


    return (
      <div>
        {serverAlert.map((data, i) => {
          const { openSnackbar, variant, message, id } = data;

          return (
            <Snackbar
              key={id}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              style={{ top: `${i * 75 + 30}px`, zIndex: 99999 }}
              open={openSnackbar}
              autoHideDuration={3000}
              onClose={() => this.props.hideAlert(id || '')}
            >
              <MySnackbarContentWrapper
                onClose={() => this.props.hideAlert(id || '')}
                variant={variant}
                message={message}
              />
            </Snackbar>
          );
        })}

      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    serverAlert: state.commonData.serverAlert
  }
}

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
  {
    hideAlert: serverAlertActions.hideAlert
  },
  dispatch
)

//@ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles2)(MyPATSnackbar));